var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"how-it-works"},[(_vm.isLoggedIn)?_c('cmg-member-loyalty-rewards',{staticClass:"rewards"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }